import React, { Component } from "react";
import { Icon, Row, Col, Result, Button } from "antd";

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      strings: this.props.language
    };
  }

  render() {
    return (
      <div
        id="errorPage"
        className={!this.props.bookingLoaded ? "error-page" : "d-none"}
      >
        <Result
          status="500"
          title={this.props.translations && this.props.translations.loadBookingError}
          subTitle={this.props.bookingLoadedErrorMessage}
        />
      </div>
    );
  }
}

export default ErrorPage;

/*  Old error page
<Row>
	<Col offset={6} span={8}>
		<h1 data-translationkey="error">

		</h1>
		<h2 data-translationkey="somethingWrong" />
		<span
			className="error-page-message d-none"
			data-translationkey="loadBookingError"
		>
			{this.props.translations &&
				this.props.translations.loadBookingError}
		</span>
		<p className="error-page-response" />
	</Col>
	<Col span={10}>

	</Col>
</Row>
*/



// WEBPACK FOOTER //
// ./src/components/ErrorPage.js